export enum GenericUploadRowConflictError {
  RowExceedsHeaderCount = "RowExceedsHeaderCount",
  RowDuplicated = "RowDuplicated",
  EntityNotFound = "EntityNotFound",
  EntityNotSupported = "EntityNotSupported",
  ValueNotValid = "ValueNotValid",
  ValidationFailed = "ValidationFailed",
  PhoneDuplicatedInFile = "PhoneDuplicatedInFile",
  PhoneAlreadyInUse = "PhoneAlreadyInUse",
}

export enum GenericUploadColumnConflictError {
  ReadPermissionDenied = "ReadPermissionDenied",
  ReadOnlyColumn = "ReadOnlyColumn",
  EntityNotSupported = "EntityNotSupported",
}
